// =============================================================================
// Util: visibilidad del módulo de Cuenta Corriente de clientes (cc-visibility.util.ts)
// Con Total C.C. deshabilitado el negocio no genera deuda nueva, así que el módulo solo se
// muestra mientras queden cuentas con saldo (deuda o saldo a favor) para cobrar o consultar.
// =============================================================================

/**
 * Indica si la modalidad Total C.C. está habilitada en businesses.settings.enabled_payment_modalities.
 * Sin configurar (lista ausente o vacía) se asumen las modalidades clásicas, que incluyen total_cc.
 */
export function totalCcHabilitada(settings: unknown): boolean {
  const configuradas = (settings as { enabled_payment_modalities?: unknown } | null)?.enabled_payment_modalities;
  if (!Array.isArray(configuradas) || configuradas.length === 0) return true;
  return configuradas.includes('total_cc');
}

/**
 * El módulo C.C. (menú, botón del listado y rutas) se muestra si Total C.C. está habilitada o si
 * quedan cuentas con saldo distinto de cero. Mientras no se sabe si hay saldos (undefined) con
 * Total C.C. apagada se oculta, igual que el menú de Vales.
 */
export function mostrarModuloCc(settings: unknown, hayCuentasConSaldo: boolean | undefined): boolean {
  return totalCcHabilitada(settings) || hayCuentasConSaldo === true;
}
